// theme.js
export const theme = {
  typography: {
    fontFamily: "'Inter', sans-serif", // Default body font
    headingFontFamily: "'Montserrat', sans-serif", // Heading font
  },
  colors: {
    primary: {
      dark: "#07143c",
      main: "#0A1D56",
      light: "#3b4a77",
    },
    secondary: {
      dark: "#3550a9",
      main: "#4c73f2",
      light: "#6f8ff4",
    },
    success: {
      dark: "#1c7430",
      main: "#28a745",
      light: "#53b86a",
    },
    danger: {
      dark: "#9a2530",
      main: "#e86c78",
      light: "#e35d6a",
    },
    warning: {
      dark: "#b28704",
      main: "#ffc107",
      light: "#ffcd38",
    },
    info: {
      dark: "#b26500",
      main: "#ff9100",
      light: "#ffa733",
    },
    light: {
      dark: "#dddddd",
      main: "#f5f5f5",
      light: "#ffffff",
    },
    dark: {
      dark: "#000",
      main: "#475467",
      light: "#666",
    },
    default: {
      dark: "#344054",
      main: "#D0D5DD",
      light: "#999",
    },
    background: {
      main: "#f1f5f9",
    },
  },
  // Font sizes (based on shadcn's type scale)
  fontSize: {
    xs: "0.75rem", // 12px
    sm: "0.875rem", // 14px
    base: "1rem", // 16px
    lg: "1.125rem", // 18px
    xl: "1.25rem", // 20px
    "2xl": "1.5rem", // 24px
    "3xl": "1.875rem", // 30px
  },
  // Spacing scale (consistent spacing units)
  space: {
    1: "0.25rem", // 4px
    1.5: "0.375rem", // 8px
    2: "0.5rem", // 8px
    3: "0.75rem", // 12px
    4: "1rem", // 16px
    5: "1.25rem", // 20px
    6: "1.5rem", // 24px
    8: "2rem", // 32px
    10: "2.5rem", // 40px
    12: "3rem", // 48px
    16: "4rem", // 64px
    20: "5rem", // 80px
  },
  // Border radius
  radius: {
    card: "0.9375rem",
    list: "0.625rem",
    element: "0.5rem",
    sm: "0.125rem", // 2px
    md: "0.375rem", // 6px
    lg: "0.5rem", // 8px
    xl: "0.75rem", // 12px
    "2xl": "1rem", // 16px
    full: "100%", // Full circular radius
  },
  // Shadows (following shadcn/ui pattern)
  shadow: {
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  },
};